(() => {
  if (customElements.get('bhc-seasonal-video')) return;
  customElements.define('bhc-seasonal-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = false;
      this.inView = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.manualPause = false;
          this.play();
        } else {
          this.manualPause = true;
          this.video.pause();
        }
      }, options);
      this.video.addEventListener('play', () => this.label(true), options);
      this.video.addEventListener('pause', () => this.label(false), options);
      this.video.addEventListener('error', () => this.classList.remove('is-ready'), options);
      this.motion.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.05 });
      this.observer.observe(this.closest('section'));
    }
    label(playing) {
      this.button.textContent = playing ? 'Pause animation' : 'Play animation';
      this.button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} Christmas hero animation`);
    }
    sync() {
      if (this.inView && !document.hidden && !this.motion.matches && !this.manualPause) this.play();
      else this.video.pause();
    }
    async play() {
      if (!this.video.querySelector('source').hasAttribute('src')) {
        const source = this.video.querySelector('source');
        source.src = matchMedia('(max-width: 749px)').matches && source.dataset.mobileSrc
          ? source.dataset.mobileSrc : source.dataset.src;
        this.video.load();
      }
      this.video.muted = true;
      try {
        await this.video.play();
        this.classList.add('is-ready');
      } catch { this.label(false); }
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
})();
